const SvgIcon = ({ id, href, className }) => (
  <svg className={className}>
    <use href={`${href}#${id}`} />
  </svg>
);

export default SvgIcon;
